import React from 'react';

import {Icon, Text} from '@albert-io/atomic';

export function EmptyState() {
  return (
    <div className='flex w-full flex-col items-center justify-center gap-x2 border border-border-subtle p-x4'>
      <div className='flex h-x5 w-x5 items-center justify-center rounded-full background-bold'>
        <Icon icon={['far', 'books']} color='tertiary' />
      </div>
      <Text color='secondary'>No subjects available for practice.</Text>
    </div>
  );
}
